import React from 'react'

const Title = ({text1 , text2}) => {
  return (
    <div className='flex justify-between items-center text-xl sm:text-2xl mb-4'>
      <div className='flex-1'>
              <div className='inline-flex gap-2 items-center mb-3'>
        <p className='text-gray-500'>{text1}<span className='text-gray-700 font-medium'> {text2}</span> </p>
        <p className='w-8 md:w-11 h-[2px] bg-gray-700'></p>
      </div>
      </div>

    </div>
  )
}

export default Title